import { render, staticRenderFns } from "./Inlead.vue?vue&type=template&id=35e4115d&"
import script from "./Inlead.vue?vue&type=script&lang=js&"
export * from "./Inlead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports